import { baseApi } from 'store/api/base-api';
import { Language, LanguagesResponse } from 'types/settings';

export const settingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLanguages: builder.query<Array<Language>, void>({
      query: () => ({ url: '/api/languages', method: 'GET' }),
      transformResponse: (response: LanguagesResponse): Array<Language> => {
        const { languages } = response;
        return languages.map((language) => ({
          code: language.code,
          name: language.nativeName,
        }));
      },
    }),
  }),
});

export const { useGetLanguagesQuery } = settingsApi;
